import type { NotifyMeMessageType } from '@velasca/types'
import { isSummerNotifyMe } from './isSummerNotifyMe'
import { isWinterNotifyMe } from './isWinterNotifyMe'

type ValidTranslationKey =
  | 'back_in_stock_title_winter'
  | 'back_in_stock_title_summer'
  | 'back_in_stock_title'
  | 'limited'

/**
 * Returns a string key used in react-i18next useLocalization's translation method
 * to print the correct "back in stock" text based on the product season availability.
 *
 * @param notifyMe - The notify message type.
 * @returns A translation key or undefined.
 */
export const getBackInStockTranslationKey = (
  notifyMe: NotifyMeMessageType | undefined,
): ValidTranslationKey => {
  if (notifyMe === 'limited') {
    return 'limited'
  }

  if (notifyMe === 'season-winter') {
    return isWinterNotifyMe()
      ? 'back_in_stock_title'
      : 'back_in_stock_title_winter'
  }

  if (notifyMe === 'season-summer') {
    return isSummerNotifyMe()
      ? 'back_in_stock_title'
      : 'back_in_stock_title_summer'
  }

  return 'back_in_stock_title'
}
